import { XMarkIcon } from "@heroicons/react/24/outline";

interface CategorySelectedBannerProps {
  categoryName: string;
  onCancel: () => void;
}

const CategorySelectedBanner: React.FC<CategorySelectedBannerProps> = ({ categoryName, onCancel }) => {
  return (
    <div className="flex items-center justify-between bg-blue-50 border border-blue-200 rounded-md px-4 py-2">
      <span className="font-semibold text-blue-900">{categoryName}</span>
      <button
        type="button"
        onClick={onCancel}
        className="btn-custom p-1 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded transition-colors"
        aria-label="Change category"
      >
        <XMarkIcon className="w-5 h-5" />
      </button>
    </div>
  );
};

export default CategorySelectedBanner;
